import { Box, Button } from "@mui/material";
import React from "react";

const MonthItem = ({ month, onClick, isFirst, isLast, selected }) => {
	const isFirstOrLast = isFirst || isLast;
	return (
		<Box
			sx={(theme) => ({
				pl: isFirst ? 0 : 0.5,
				ml: !isFirst ? 0 : 0.5,
				pr: isLast ? 0 : 0.5,
				mr: !isLast ? 0 : 0.5,
				borderTopLeftRadius: isFirst ? theme.shape.borderRadius : 0,
				borderBottomLeftRadius: isFirst ? theme.shape.borderRadius : 0,
				borderTopRightRadius: isLast ? theme.shape.borderRadius : 0,
				borderBottomRightRadius: isLast ? theme.shape.borderRadius : 0,
				my: 0.5,
				backgroundColor: selected ? theme.palette.action.hover : undefined,
			})}
		>
			<Button
				onClick={onClick}
				variant={selected && isFirstOrLast ? "contained" : "text"}
				size="small"
				color={"primary"}
				fullWidth
			>
				{month}
			</Button>
		</Box>
	);
};

export default MonthItem;
